import React from 'react';

export const PowerBISearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M30.381 5H22.4286C21.7448 5 21.1905 5.55431 21.1905 6.2381V33.7619C21.1905 34.4457 21.7448 35 22.4286 35H30.381C31.0647 35 31.6191 34.4457 31.6191 33.7619V6.2381C31.6191 5.55431 31.0647 5 30.381 5Z"
			fill="url(#paint0_linear_powerbi)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.4762 33.7619V35H16.2857C15.6019 35 15.0476 34.4457 15.0476 33.7619V13.7143C15.0476 13.0305 15.6019 12.4762 16.2857 12.4762H24.2381C24.9219 12.4762 25.4762 13.0305 25.4762 13.7143V33.7619Z"
			fill="black"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.4762 33.7619V35H16.2857C15.6019 35 15.0476 34.4457 15.0476 33.7619V13.7143C15.0476 13.0305 15.6019 12.4762 16.2857 12.4762H24.2381C24.9219 12.4762 25.4762 13.0305 25.4762 13.7143V33.7619Z"
			fill="url(#paint1_linear_powerbi)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.4286 33.7619V35H10.2381C9.55429 35 9 34.4457 9 33.7619V21.2381C9 20.5543 9.55429 20 10.2381 20H18.1905C18.8743 20 19.4286 20.5543 19.4286 21.2381V33.7619Z"
			fill="url(#paint2_linear_powerbi)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_powerbi"
				x1="26.3553"
				y1="4.9619"
				x2="26.3553"
				y2="34.9619"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#EBBB14" />
				<stop offset="1" stopColor="#B25400" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_powerbi"
				x1="20.2124"
				y1="12.3833"
				x2="20.2124"
				y2="34.9071"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F9E583" />
				<stop offset="1" stopColor="#DE9800" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_powerbi"
				x1="14.1648"
				y1="19.9619"
				x2="14.1648"
				y2="34.9619"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F9E68B" />
				<stop offset="1" stopColor="#F3CD32" />
			</linearGradient>
		</defs>
	</svg>
);
